export default "__VITE_ASSET__hIoXKuKm__"